import { takeLatest } from 'redux-saga/effects'
import { FETCH_TEMPLATE_PHRASES_SAGA } from 'src/store/types/templatePhrases'
import fetchTemplatePhrases from './fetchTemplatePhrases'

export function* templatePhrasesSaga() {
  yield takeLatest(FETCH_TEMPLATE_PHRASES_SAGA, fetchTemplatePhrases)
}
